import type { PhotoEffectId } from '@/lib/photo-effects/types/photo-effect-id'

/** Stable map from UI effect id → Core 3 `effectName` / transform `tx`. */
export const PHOTO_EFFECT_ID_TO_TX: Readonly<Record<PhotoEffectId, string>> = {
  autoBrightness: 'auto_brightness',
  autoContrast: 'auto_contrast',
  autoColor: 'auto_color',
  grayscale: 'grayscale',
  improveIndoor: 'improve:indoor',
  improveOutdoor: 'improve:outdoor',
  redEye: 'redeye',
  brightness: 'brightness',
  contrast: 'contrast',
  gamma: 'gamma',
  saturation: 'saturation',
  vibrance: 'vibrance',
  blur: 'blur',
  fillLight: 'fill_light',
  sepia: 'sepia',
  sharpen: 'sharpen',
  cartoonify: 'cartoonify',
  oilPainting: 'oil_paint',
}

const TX_TO_PHOTO_EFFECT_ID = new Map<string, PhotoEffectId>(
  Object.entries(PHOTO_EFFECT_ID_TO_TX).map(([id, tx]) => [tx, id as PhotoEffectId])
)

export function photoEffectIdFromTx(tx: string): PhotoEffectId | null {
  return TX_TO_PHOTO_EFFECT_ID.get(tx.trim()) ?? null
}

export function photoEffectTxFromId(id: PhotoEffectId): string {
  return PHOTO_EFFECT_ID_TO_TX[id]
}
